export const common = {
  // Navigation
  nav_home: "Bosh sahifa",
  nav_hospitals: "Shifoxonalar",
  nav_services: "Xizmatlar",
  nav_posts: "Maqolalar",
  nav_about: "Biz haqimizda",
  nav_contact: "Aloqa",
  
  // Auth
  login: "Kirish",
  signup: "Ro'yxatdan o'tish",
  logout: "Chiqish",
  welcome_user: "Xush kelibsiz",
  email: "Elektron pochta",
  password: "Parol",
  confirm_password: "Parolni tasdiqlang",
  full_name: "To'liq ism",
  phone: "Telefon raqami",
  forgot_password: "Parolni unutdingizmi?",
  
  // Hero Section
  hero_title: "Janubiy Koreyadagi zamonaviy va ilg'or tibbiy xizmatlar",
  hero_subtitle: "MediVoyage xalqaro bemorlarni Janubiy Koreyadagi ishonchli shifoxonalar va tajribali shifokorlar bilan bog'laydi",
  hero_description: "Biz Koreyaga davolanish maqsadida kelayotgan bemorlar uchun onlayn tibbiy konsultatsiyalarni tashkil etish, mos shifoxona va malakali shifokorlar bilan uchrashuvlarni rejalashtirish, professional tarjimon xizmatini ta'minlash hamda Koreyaning diqqatga sazovor turistik hududlariga sayohatlarni tashkil qilish bo'yicha kompleks yordam ko'rsatamiz",
  hero_cta_primary: "Bepul konsultatsiya",
  hero_cta_secondary: "Xizmatlarni ko'rish",
  
  // Search
  search_placeholder: "Shifoxona, xizmat yoki muolaja turini qidiring...",
  search_button: "Qidirish",
  
  // Services Menu
  services_title: "Bizning Xizmatlarimiz",
  services_subtitle: "Keng ko'lamli tibbiy xizmatlar va to'liq qo'llab-quvvatlash",
  
  service_dental: "Stomatologiya",
  service_dental_desc: "Implantlar, laminatlar, oqartirish, toj davolash",
  
  service_plastic: "Plastik jarrohlik",
  service_plastic_desc: "Yuz ko'tarish, ko'z operatsiyalari, ko'krak operatsiyasi, liposaktsiya",
  
  service_antiaging: "Anti-aging",
  service_antiaging_desc: "Ildiz hujayra terapiyasi, NAD in'ektsiyalari",
  
  service_orthopedic: "Ortopediya",
  service_orthopedic_desc: "Tizza bo'g'im davolash, ildiz hujayra/kollagen terapiyasi",
  
  service_eye: "Ko'z kasalliklari",
  service_eye_desc: "LASIK, LASEK, Smile Lasik operatsiyalari",
  
  service_skin: "Teri parvarishi",
  service_skin_desc: "Petit, lifting, skin booster, teri parvarishi",
  
  service_cancer: "Saraton davolash",
  service_cancer_desc: "Saraton operatsiyasi, kimyoterapiya",
  
  service_spine: "Umurtqa pog'onasi",
  service_spine_desc: "Bel disk operatsiyasi",
  
  service_proctology: "Proktologiya",
  service_proctology_desc: "Bavasir, anal yorilish operatsiyasi",
  
  service_gynecology: "Ginekologiya",
  service_gynecology_desc: "Ginekologik tekshiruv, bepushtlik markazi",
  
  service_checkup: "Kompleks tekshiruv",
  service_checkup_desc: "To'liq sog'liqni tekshirish dasturi",

  service_hair_transplant: "Soch ko'chirish",
  service_hair_transplant_desc: "FUE, DHI usullari bilan soch ko'chirish operatsiyasi",

  service_varicose: "Varikoz davolash",
  service_varicose_desc: "Oyoq venalari kengayishi, lazer va skleroterapi davolash",
  
  // News & Events
  news_title: "Yangiliklar va Tadbirlar",
  news_subtitle: "Eng so'nggi tibbiy turizm yangiliklari va maxsus takliflar",
  read_more: "Batafsil",
  
  // Chat Consultation
  chat_title: "Onlayn Konsultatsiya",
  chat_subtitle: "Professional tibbiy tarjimonlar bilan 24/7 qo'llab-quvvatlash",
  chat_cta: "Suhbatni boshlash",
  chat_description: "Bizning mutaxassislarimiz sizga yordam berishga tayyor. Savollaringizni bering va bepul konsultatsiya oling.",
  
  // Recommendations
  recommendations_title: "Sizga Tavsiya Etilgan",
  recommendations_subtitle: "Ehtiyojlaringizga mos keladigan maxsus xizmatlar",

  rec_knee_stem_title: "Tizza ildiz hujayra terapiyasi",
  rec_knee_stem_desc: "Tizza bo'g'imi uchun zamonaviy hujayrali terapiya",
  rec_knee_stem_duration: "2-3 soat",
  rec_upper_eyelid_title: "Yuqori qovoq operatsiyasi",
  rec_upper_eyelid_desc: "Yuqori qovoq operatsiyasi, ko'z ochilishi",
  rec_upper_eyelid_duration: "1-2 soat",
  rec_rhinoplasty_title: "Rinoplastika",
  rec_rhinoplasty_desc: "Burun shakli tuzatish, burun ko'tarish",
  rec_rhinoplasty_duration: "2-3 soat",
  rec_skin_care_title: "Teri parvarishi",
  rec_skin_care_desc: "Lifting, botoks, filler, lazer terapiya",
  rec_skin_care_duration: "30-60 daqiqa",
  rec_teeth_whitening_title: "Tish oqartirish",
  rec_teeth_whitening_desc: "Professional tish oqartirish, estetik stomatologiya",
  rec_teeth_whitening_duration: "1-2 soat",
  rec_health_checkup_title: "Kompleks tekshiruv dasturi",
  rec_health_checkup_desc: "To'liq tibbiy tekshiruv va diagnostika",
  rec_health_checkup_duration: "4-6 soat",
  rec_breast_surgery_title: "Ko'krak operatsiyasi",
  rec_breast_surgery_desc: "Ko'krak augmentatsiyasi va shakl tuzatish",
  rec_breast_surgery_duration: "2-3 soat",
  rec_facelift_title: "Yuz ko'tarish operatsiyasi",
  rec_facelift_desc: "Yuz terisi tortish, yoshartirish operatsiyasi",
  rec_facelift_duration: "3-4 soat",
  
  // Consultation Popup
  popup_consultation_title: "Konsultatsiya band qilish",
  popup_treatment: "Tibbiy yo'nalish",
  popup_name: "Ism",
  popup_name_placeholder: "Ismingizni kiriting",
  popup_phone: "Telefon",
  popup_phone_placeholder: "+998 XX XXX XX XX",
  popup_email: "Elektron pochta",
  popup_email_placeholder: "email@example.com",
  popup_message: "Qo'shimcha ma'lumot",
  popup_message_placeholder: "Savolingiz yoki xohishingizni yozing...",
  popup_submit: "Ariza yuborish",
  popup_submitting: "Yuborilmoqda...",
  popup_success_title: "Ariza yuborildi!",
  popup_success_msg: "Mutaxassislarimiz 24 soat ichida siz bilan bog'lanadilar.",
  popup_close: "Yopish",
  popup_error_msg: "Xatolik yuz berdi. Qayta urinib ko'ring.",
  
  // Partner Hospitals
  hospitals_title: "Hamkor Shifoxonalar",
  hospitals_subtitle: "Janubiy Koreyaning eng yaxshi tibbiy muassasalari bilan hamkorlik",
  view_details: "Batafsil ma'lumot",
  view_all_hospitals: "Barcha shifoxonalarni ko'rish",
  
  // Why Choose Us
  why_choose_title: "Nima uchun MediVoyage?",
  why_choose_subtitle: "To'liq tibbiy turizm tajribasi",
  
  feature_interpreter: "Professional tibbiy tarjimonlar",
  feature_interpreter_desc: "Shifokorlar bilan muloqot davomida professional tarjimonlar xizmati",
  
  feature_visa: "Viza yordami",
  feature_visa_desc: "Tibbiy turizm vizasini olishda to'liq yordam",
  
  feature_accommodation: "Turar joy va sayohat",
  feature_accommodation_desc: "Shifoxona yaqinidagi mehmonxonalar va sayohat dasturlari",
  
  feature_consultation: "Onlayn konsultatsiya",
  feature_consultation_desc: "Koreyaga kelishdan oldin onlayn konsultatsiya",
  
  feature_support: "24/7 qo'llab-quvvatlash",
  feature_support_desc: "Sayohatingiz davomida doimiy qo'llab-quvvatlash",
  
  feature_package: "To'liq paket",
  feature_package_desc: "Konsultatsiyadan davolanish va sayohatgacha hamma narsa",
  
  // Footer
  footer_about: "MediVoyage haqida",
  footer_about_text: "Biz Koreyaga davolanish maqsadida kelayotgan bemorlar uchun onlayn tibbiy konsultatsiyalarni tashkil etish, mos shifoxona va malakali shifokorlar bilan uchrashuvlarni rejalashtirish, professional tarjimon xizmatini ta\'minlash hamda Koreyaning diqqatga sazovor turistik hududlariga sayohatlarni tashkil qilish bo\'yicha kompleks yordam ko\'rsatamiz.",
  footer_quick_links: "Tezkor havolalar",
  footer_services: "Xizmatlar",
  footer_contact_us: "Biz bilan bog'laning",
  footer_address: "Manzil",
  footer_email_label: "Elektron pochta",
  footer_phone_label: "Telefon",
  footer_follow_us: "Bizni kuzatib boring",
  footer_rights: "© 2025 MediVoyage. Barcha huquqlar himoyalangan.",
  
  // Common
  learn_more: "Batafsil",
  contact_us: "Biz bilan bog'laning",
  book_now: "Hozir band qiling",
  get_started: "Boshlash",
  view_all: "Hammasini ko'rish",

  // Contact Section
  contact_badge: "Aloqa",
  contact_title: "Biz bilan bog'laning",
  contact_subtitle: "Savollaringiz bormi? Mutaxassislarimiz sizga yordam berishga tayyor.",
  contact_office_uz: "O'zbekiston",
  contact_office_kr: "Koreya",
  contact_email_label: "Elektron pochta",
  contact_social_title: "Ijtimoiy tarmoqlarda kuzatib boring",
  contact_form_title: "Xabar yuborish",
  contact_service_label: "Xizmat turi",
  contact_service_placeholder: "Xizmatni tanlang",
  contact_service_consultation: "Tibbiy konsultatsiya",
  contact_service_visa: "Viza yordami",
  contact_service_accommodation: "Turar joy va mehmonxona",
  contact_service_interpreter: "Tibbiy tarjimon xizmati",
  contact_service_tour: "Sayohat va ekskursiya",
  contact_service_package: "To'liq tibbiy paket",
  contact_specialty_label: "Kerakli tibbiy yo'nalish",
  contact_specialty_placeholder: "Yo'nalishni tanlang",
  contact_specialty_dental: "Stomatologiya",
  contact_specialty_plastic: "Plastik jarrohlik",
  contact_specialty_eye: "Ko'z kasalliklari (LASIK/LASEK)",
  contact_specialty_skin: "Teri parvarishi va estetika",
  contact_specialty_orthopedic: "Ortopediya va bo'g'im",
  contact_specialty_spine: "Umurtqa pog'onasi",
  contact_specialty_cancer: "Saraton davolash",
  contact_specialty_gynecology: "Ginekologiya va bepushtlik",
  contact_specialty_antiaging: "Anti-aging va ildiz hujayra",
  contact_specialty_checkup: "Kompleks tibbiy tekshiruv",
  contact_specialty_proctology: "Proktologiya",
  contact_specialty_other: "Boshqa",
  contact_visit_date_label: "Kerakli tashrif sanasi",
  contact_visit_date_hint: "Taxminiy sana bo'lsa ham yozing",
  contact_message_label: "Xabar",
  contact_submit: "Yuborish",
  contact_sending: "Yuborilmoqda...",
  contact_success_title: "Xabar yuborildi!",
  contact_success_msg: "Tez orada siz bilan bog'lanamiz.",
  contact_send_another: "Yana xabar yuborish",
  contact_error_msg: "Xatolik yuz berdi. Iltimos, qayta urinib ko'ring.",

  // Hospital Detail
  hospital_detail_specialties: "Mutaxassisliklar",
  hospital_detail_about: "Shifoxona haqida",
  hospital_detail_location: "Joylashuv",
  hospital_detail_contact_info: "Aloqa ma'lumotlari",
  hospital_detail_website: "Veb-sayt",
  hospital_detail_phone: "Telefon",
  hospital_detail_address: "Manzil",
  hospital_detail_consultation: "MediVoyage orqali konsultatsiya",
  hospital_detail_consultation_desc: "Ushbu shifoxonada davolanish uchun bepul konsultatsiya oling",
  hospital_detail_book_consultation: "Konsultatsiya band qilish",
  back_to_list: "Ro'yxatga qaytish",

  // Privacy Consent
  privacy_consent: "Shaxsiy ma'lumotlarni qayta ishlashga roziman",
  privacy_consent_required: "Shaxsiy ma'lumotlarni qayta ishlashga rozilik talab etiladi",
  privacy_policy: "Maxfiylik siyosati",
};

export default common;
